<router-outlet></router-outlet>
<ps-toast />
